// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"d982b775","214":"678bcd3e","249":"b164438a","327":"fec8a906","404":"7cf50d5e","411":"7cbb36be","514":"b1ca5d29","527":"ffe96211","556":"70484e05","676":"7234f648","725":"d152a2aa"}[chunkId] + ".chunk.js";
};